import { render, staticRenderFns } from "./View.vue?vue&type=template&id=57cad3ae&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cad3ae')) {
      api.createRecord('57cad3ae', component.options)
    } else {
      api.reload('57cad3ae', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=57cad3ae&", function () {
      api.rerender('57cad3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warehouse/orders/ccsheet/View.vue"
export default component.exports